module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-tabbed-view"
  }, [_c('div', {
    key: _vm.a,
    staticClass: "u-tabbed-view-tabs"
  }, _vm._l((_vm.tabs), function(c) {
    return _c('a', {
      class: {
        'u-tabbed-view-tab': true,
        'u-tabbed-view-tab--active': c.active
      },
      on: {
        "click": function($event) {
          _vm.setActive(c)
        }
      }
    }, [_vm._v(_vm._s(c.header))])
  })), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d8b0a7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/TabbedView.vue
// module id = 498
// module chunks = 2